import classNames from 'classnames'
import { ChangeEvent, ChangeEventHandler, ReactNode } from 'react'
import { Button } from '../button'
import Icon from '../icon'
import { TextInput } from './textInput'

export const EditInput = ({
  title,
  value,
  onChange,
  type,
  inputName,
  errors,
  placeholder,
  onEditSave,
  editing,
  onEditClick,
  onCancel,
  loading = false,
  disabled = false,
  className,
  mode = 'edit',
  children,
  buttonText = 'Save',
  buttonClassName = '',
  maxLength,
}: {
  title: string
  value?: string
  onChange?: ((
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void) &
    ChangeEventHandler<HTMLInputElement>
  type?: string
  inputName?: string
  errors?: string
  placeholder?: string
  onEditSave: () => void
  editing: boolean
  onEditClick?: () => void
  onCancel: () => void
  loading?: boolean
  disabled?: boolean
  className?: string
  mode?: 'edit' | 'new'
  children?: (props: { isEditing: boolean }) => ReactNode
  buttonText?: string
  buttonClassName?: string
  maxLength?: number
}) => {
  return (
    <div
      className={`
      flex flex-col
      w-full
      ${editing ? 'gap-4' : 'gap-2'}
      ${className}
      transition-all duration-300
      `}
    >
      {mode === 'edit' && (
        <div className="flex items-center justify-between">
          <span className="font-medium text-base">{title}:</span>

          {onEditClick ? (
            <button
              type="button"
              onClick={() => {
                if (editing) {
                  onCancel()
                } else {
                  onEditClick()
                }
              }}
              className="flex items-center gap-2"
            >
              {editing ? (
                'Cancel'
              ) : (
                <>
                  <span>Edit</span> <Icon id="edit" width={20} height={20} />
                </>
              )}
            </button>
          ) : undefined}
        </div>
      )}

      {children ? (
        <>
          {!editing && errors ? (
            <div
              className={classNames('text-sec-black', {
                '!text-danger': !!errors,
              })}
            >
              {errors}
            </div>
          ) : (
            children({ isEditing: editing })
          )}
        </>
      ) : (
        <>
          {editing || mode === 'new' ? (
            <TextInput
              hasIcon={false}
              value={value}
              onChange={onChange}
              type={type}
              placeholder={placeholder}
              name={inputName}
              errors={errors}
              title={mode === 'new' ? title : undefined}
              maxLength={maxLength}
            />
          ) : (
            <div
              className={classNames('text-sec-black', {
                '!text-danger': !!errors,
              })}
            >
              {!!value && !errors ? value : undefined}
              {!value && !errors ? `No ${title} provided` : undefined}
              {errors ? errors : undefined}
            </div>
          )}
        </>
      )}

      {editing && mode === 'edit' ? (
        <Button
          type="button"
          primary
          loading={loading}
          disabled={loading || disabled}
          label={buttonText}
          className={classNames('max-w-[160px]', buttonClassName)}
          onClick={() => {
            onEditSave()
          }}
        />
      ) : undefined}
    </div>
  )
}
